export const generateManifest = (data) => {
  return {
    name: data.restaurantName,
    short_name: data.restaurantName,
    description: data.restaurantName,
    start_url: "/",
    display: "standalone",
    background_color: "#ffffff",
    theme_color: "#000000",
    icons: [
      {
        src: data.companyLogo,
        sizes: "192x192",
        type: "image/png",
      },
      {
        src: data.companyLogo,
        sizes: "512x512",
        type: "image/png",
      },
    ],
  };
};

export const injectManifest = (manifest) => {
  const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("link");
  link.rel = "manifest";
  link.href = url;
  document.head.appendChild(link);
};
